export default class DtoDistributionUnitSector {
    constructor(obj) {
        this.distributionUnitId = obj.distributionUnitId
        this.id = obj.id
        this.code = obj.id
        this.name = obj.name
        this.comment = obj.comment
    }
}